module.exports = __webpack_public_path__ + "assets/img/block-left-a1fdbb9b.png";